import React from "react";
const Privacy = () => {
  return (
    <>
      <div className="privacy-policy terms-and-condition container">
        <h1>Privacy Policy</h1>
        <div className="mt-3 mb-5">
          <p>
            Welcome to Rolidex App. By accessing or using our website and mobile
            application, you agree to comply with the following Terms and
            Conditions.
          </p>

          <h4 className="mt-4 mb-2 span-kansensus">1. Acceptance of Terms</h4>
          <p>
            By using our platform, you agree to these Terms, our Privacy Policy,
            and any applicable laws governing digital communications. If you do
            not agree, please refrain from using our services.
          </p>

          <h4 className="mt-4 mb-2 span-kansensus">
            2. Account Registration & Usage
          </h4>
          <ul>
            <li>
              • You must provide accurate and complete information when creating
              an account.
            </li>
            <li>
              • You are responsible for maintaining the confidentiality of your
              login credentials.
            </li>
            <li>• Unauthorized use of your account is strictly prohibited.</li>
          </ul>

          <h4 className="mt-4 mb-2 span-kansensus">3. Services & Features</h4>
          <ul>
            <li>
              • We provide a digital business card solution, including scanning,
              storing, and sharing contacts.
            </li>
            <li>
              • We may update, modify, or discontinue services at any time
              without prior notice.
            </li>
            <li>
              • Users are expected to use the platform for lawful business
              networking purposes.
            </li>
          </ul>

          <h4 className="mt-4 mb-2 span-kansensus">4. User Responsibilities</h4>
          <ul>
            <li>• Do not share misleading or false information.</li>
            <li>
              • Do not engage in spam, unauthorized marketing, or any fraudulent
              activities.
            </li>
            <li>
              • Respect the privacy and intellectual property rights of other
              users.
            </li>
          </ul>

          <h4 className="mt-4 mb-2 span-kansensus">
            5. Payments & Subscriptions (If applicable)
          </h4>
          <ul>
            <li>
              • Certain features may require a subscription or one-time payment.
            </li>
            <li>
              • Payments are processed through secure third-party gateways.
            </li>
            <li>
              • Refund policies will be outlined within the app’s billing
              section.
            </li>
          </ul>

          <h4 className="mt-4 mb-2 span-kansensus">
            6. Data Privacy & Security
          </h4>
          <ul>
            <li>• We prioritize your data security and encryption.</li>
            <li>
              • Your personal information will be handled according to our
              Privacy Policy.
            </li>
            <li>
              • We do not sell or share your data with third parties for
              marketing purposes.
            </li>
          </ul>

          <h4 className="mt-4 mb-2 span-kansensus">
            7. Termination of Service
          </h4>
          <p>
            We reserve the right to suspend or terminate accounts that violate
            our Terms & Conditions, including fraudulent activity, abuse, or
            security breaches.
          </p>

          <h4 className="mt-4 mb-2 span-kansensus">
            8. Limitation of Liability
          </h4>
          <ul>
            <li>
              • We are not responsible for data loss, third-party misuse, or
              technical failures.
            </li>
            <li>
              • Our platform is provided as-is, without any guarantees of
              uninterrupted service.
            </li>
          </ul>

          <h4 className="mt-4 mb-2 span-kansensus">9. Changes to Terms</h4>
          <p>
            We may update these Terms & Conditions at any time. Continued use of
            our services after changes are made signifies your acceptance.
          </p>

          <h4 className="mt-4 mb-2 span-kansensus">10. Contact Us</h4>
          <p>
            For any inquiries, please reach out to{" "}
            <a href="mailto:yolanda@rolidexapp.com">yolanda@rolidexapp.com</a>.
          </p>
        </div>
      </div>
    </>
  );
};
export { Privacy };
